import { CurrencyAmount, DummyCurrencyAmount } from '@core/models/currency-amount.model';
import { Action, createReducer, on } from '@ngrx/store';
import { fullUpdateFinancialInfo } from '@redux/actions/financial-info.actions';

export interface FinancialInfo {
  situation: string;
  features: {
    monthlyIncomes: FinancialInfoFeatureAmount;
    monthlyExpenses: FinancialInfoFeaturePercentage;
    savingCapacityChart: FinancialInfoFeatureChart;
    savingCapacity: FinancialInfoFeaturePercentage;
    otherIncomes: FinancialInfoFeatureAmount;
  };
  recommendations: string[];
}

export interface FinancialInfoFeature {
  text: string;
}

export interface FinancialInfoFeatureAmount extends FinancialInfoFeature {
  currencyAmount: CurrencyAmount;
}

export interface FinancialInfoFeaturePercentage extends FinancialInfoFeature {
  percentage: number;
}

export interface FinancialInfoFeatureChart extends FinancialInfoFeature {
  incomes: CurrencyAmount;
  expenses: CurrencyAmount;
  percentage: number;
}

export const initialFinancialInfo: FinancialInfo = {
  situation: '',
  features: {
    monthlyIncomes: {
      currencyAmount: DummyCurrencyAmount,
      text: ''
    },
    monthlyExpenses: {
      percentage: 0,
      text: ''
    },
    savingCapacityChart: {
      incomes: DummyCurrencyAmount,
      expenses: DummyCurrencyAmount,
      text: '',
      percentage: 0
    },
    savingCapacity: {
      percentage: 0,
      text: ''
    },
    otherIncomes: {
      currencyAmount: DummyCurrencyAmount,
      text: ''
    }
  },
  recommendations: []
};

const _financialInfoReducer = createReducer(
  initialFinancialInfo,
  on(fullUpdateFinancialInfo, (state, { newfinancialInfo }) => newfinancialInfo)
);

export function financialInfoReducer(financialInfo: FinancialInfo | undefined, action: Action) {
  return _financialInfoReducer(financialInfo, action);
}
